import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {addWarrantyExcelList} = Actions;

const ConfirmationModal = ({
  disabled,
  list,
  warrantiesTotal,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const dispatch = useDispatch();

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const addWarrantyExcel = () => {
    dispatch(addWarrantyExcelList(list, true));
    closeModal();
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  return (
    <Modal
      onOpen={openModal}
      onClose={closeModal}
      open={modalIsOpen}
      className="confirmation-excel"
      trigger={
        <Button primary disabled={disabled}>
          GENERAR
        </Button>
      }
    >
      <Modal.Header>Confirmación generación de garantias</Modal.Header>
      <Modal.Content>
        {`¿Esta seguro que desea generar ${warrantiesTotal} ${warrantiesTotal > 1 ? 'garantías' : 'garantia'}?`}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={closeModal}>Cancelar</Button>
        <Button
          positive
          icon="check"
          content="Aceptar"
          onClick={addWarrantyExcel}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmationModal;
